import { Form, Modal } from "antd";
import React, { useEffect, useState } from "react";
import OrganizationUsersTrainingCourses from "./OrganizationUsersTrainingCourses";
import {
	AddUsersToCourses,
	ITrainingCourse,
} from "src/@types/ImpiricaPlatformApi";
import { FormComponentProps } from "antd/lib/form";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { AdminPermissions } from "src/common/Permissions";
import { useApi } from "src/Api/useApi";
import { Spinner } from "src/components/common";
import { toast } from "react-toastify";

interface IProps extends FormComponentProps {
	openBulkTrainingCoursesModal: boolean;
	closeBulkTrainingCoursesModal?: () => void;
	users: number[];
	orgId: number;
}

const BulkAddTrainingCoursesModal: React.FC<IProps> = ({
	openBulkTrainingCoursesModal,
	closeBulkTrainingCoursesModal,
	users,
	orgId,
	form,
}) => {
	const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [trainingCourses, setTrainingCourses] = useState<ITrainingCourse[]>([]);
	const { trainingCourseClient } = useApi();
	const { getFieldValue } = form;

	useEffect(() => {
		_loadTrainingCourses();
	}, []);

	const _loadTrainingCourses = async () => {
		setLoading(true);
		try {
			if (trainingCourseClient) {
				const fetchedTrainingCourses =
					await trainingCourseClient.getAllTrainingCourses();
				setTrainingCourses(fetchedTrainingCourses);
				setLoading(false);
			}
		} catch (error) {
			console.error(error);
			throw error;
		}
	};

	const onHandleSave = () => {
		const trainingCourses = getFieldValue("trainingCourses");
		setButtonDisabled(true);

		onSave(trainingCourses);
	};

	const onSave = async (selectedCourseIds: number[]) => {
		const selectedUsers = users;

		setLoading(true);
		try {
			if (trainingCourseClient) {
				await trainingCourseClient.addTrainingCoursesToUsers(
					orgId,
					new AddUsersToCourses({
						userIds: selectedUsers,
						courseIds: selectedCourseIds,
					})
				);
				if (closeBulkTrainingCoursesModal) closeBulkTrainingCoursesModal();
				toast.success("Training courses added successfully");
				setLoading(false);
			}
		} catch (error) {
			toast.error("Failed to add training courses");
			setLoading(false);
		}
		setButtonDisabled(false);
	};

	return (
		<Modal
			visible={openBulkTrainingCoursesModal}
			title="Add Training Courses to the selected users"
			onCancel={closeBulkTrainingCoursesModal}
			onOk={onHandleSave}
			okText="Save"
			okButtonProps={{ disabled: buttonDisabled }}
		>
			{loading ? (
				<Spinner />
			) : (
				<Form>
					<Form.Item>
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationUser]}
						>
							{form.getFieldDecorator("trainingCourses", {
								valuePropName: "existingCourses",
							})(
								<OrganizationUsersTrainingCourses options={trainingCourses} />
							)}
						</AuthorizationWrapper>
					</Form.Item>
				</Form>
			)}
		</Modal>
	);
};

export default Form.create<IProps>()(BulkAddTrainingCoursesModal);
